<template>
  <div class="LoginForm">
    <div class="nav nav-pills extras-tabs">
      <a
        href="#"
        class="nav-link"
        :class="{ active: selectedTab === 1 }"
        @click="onSelectTab(1)"
        >INICIAR SESIÓN</a
      >
      <a
        href="#"
        class="nav-link"
        :class="{ active: selectedTab === 2 }"
        @click="onSelectTab(2)"
        >REGISTRARSE</a
      >
    </div>
    <form
      class="LoginForm__login"
      @submit.prevent="onSubmit"
      v-if="selectedTab === 1"
    >
      <div class="form-group">
        <input
          type="email"
          placeholder="CORREO ELECTRÓNICO"
          class="form-control text-center"
          v-model="formData.email"
        />
        <small v-if="formErrors['email']" class="form-text text-muted error"
          ><i class="fa fa-times" /> EL CAMPO <strong>EMAIL</strong> ES
          REQUERIDO
        </small>
      </div>
      <div class="form-group">
        <input
          type="password"
          placeholder="CONTRASEÑA"
          class="form-control text-center"
          v-model="formData.password"
        />
        <small v-if="formErrors['password']" class="form-text text-muted error"
          ><i class="fa fa-times" /> EL CAMPO <strong>CONTRASEÑA</strong> ES
          REQUERIDO
        </small>
      </div>
      <button class="btn btn-lg btn-info btn-block">
        <i class="fa fa-unlock mr-2" />
        <small>INICIAR SESIÓN</small>
      </button>
      <button
        type="button"
        class="btn btn-lg btn-secondary btn-block my-3"
        @click="onRemeberPassword"
      >
        <small>OLVIDÉ MI CONTRASEÑA</small>
      </button>
    </form>

    <form
      class="LoginForm__register"
      @submit.prevent="onRegister"
      v-if="selectedTab === 2"
    >
      <div class="form-group">
        <input
          type="email"
          placeholder="CORREO ELECTRÓNICO"
          class="form-control text-center"
          v-model="formData.email"
        />
        <small v-if="formErrors['email']" class="form-text text-muted error"
          ><i class="fa fa-times" /> EL CAMPO <strong>EMAIL</strong> ES
          REQUERIDO
        </small>
      </div>

      <div class="form-group">
        <input
          type="password"
          placeholder="CONTRASEÑA"
          class="form-control text-center"
          v-model="formData.password"
        />
        <small v-if="formErrors['password']" class="form-text text-muted error"
          ><i class="fa fa-times" /> EL CAMPO <strong>CONTRASEÑA</strong> ES
          REQUERIDO
        </small>
      </div>
      <div class="form-group">
        <input
          type="password"
          placeholder="REPETIR"
          class="form-control text-center"
          v-model="formData.passwordRepeat"
        />
        <small
          v-if="formErrors['passwordRepeat']"
          class="form-text text-muted error"
          ><i class="fa fa-times" /> LAS CONTRASEÑAS DEBEN COINCIDIR
        </small>
      </div>
      <button class="btn btn-lg btn-info btn-block">
        <i class="fa fa-edit mr-2" />
        <small>REGISTRAR USUARIO</small>
      </button>
    </form>
  </div>
</template>
<script>
import firebase from 'firebase'

export default {
  data() {
    return {
      selectedTab: 1,
      formErrors: {},
      formData: {
        email: '',
        password: '',
        passwordRepeat: '',
      },
    }
  },
  methods: {
    onSelectTab(tab) {
      this.formErrors = {}
      this.selectedTab = tab
    },
    onRemeberPassword() {
      const { email } = this.formData
      if (!email || email === '')
        this.$emit(
          'setError',
          'DEBE RELLENAR EL CAMPO DE EMAIL PARA RESTABLECER SU CONTRASEÑA'
        )
      else {
        this.$emit('userResetPassword', email)
        /* firebase.auth
          .sendPasswordResetEmail(email)
          .then(console.log)
          .catch(console.error) */
      }
    },
    onRegister() {
      const { email, password, passwordRepeat } = this.formData
      this.formErrors = {}
      if (!email || email === '')
        this.formErrors.email = 'EL EMAIL ES OBLIGATORIO'
      if (!password || password === '')
        this.formErrors.password = 'LA CONTRASEÑA ES OBLIGATORIO'
      if (!passwordRepeat || passwordRepeat !== password)
        this.formErrors.passwordRepeat = 'LAS CONTRASEÑAS DEBEN COINCIDIR'
      if (!this.formErrors.email && !this.formErrors.password) {
        this.$emit('userRegister', this.formData)
      }
    },
    onSubmit() {
      const { email, password } = this.formData
      this.formErrors = {}
      if (!email || email === '')
        this.formErrors.email = 'EL EMAIL ES OBLIGATORIO'
      if (!password || password === '')
        this.formErrors.password = 'LA CONTRASEÑA ES OBLIGATORIO'
      if (!this.formErrors.email && !this.formErrors.password) {
        this.$emit('userAuth', this.formData)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.LoginForm {
  &__login {
    margin-top: 1rem;
  }
  &__register {
    margin-top: 1rem;
  }
  .error {
    color: darkred !important;
    text-align: center;
  }
  $selected-color: #27a2b8;
  .extras-tabs {
    display: flex;
    justify-content: space-between;

    .nav-link {
      align-items: flex-end;
      border-bottom: 0.2rem solid #f2f2f2;
      border-radius: 0.4rem 0.4rem 0 0;
      color: #999999;
      display: flex;
      font-size: 1rem;
      justify-content: center;
      margin-bottom: 1rem;
      min-height: 3rem;
      padding: 0.42rem 1rem;
      position: relative;
      text-align: center;

      @media screen and (max-width: 340px) {
        font-size: 0.8rem;
      }

      &.active {
        background-color: transparent;
        border-bottom: 0.2rem solid $selected-color;
        color: $selected-color;
      }

      .badge {
        position: absolute;
        top: 0.2rem;
        right: 0;
        font-size: 0.5rem;
        font-weight: normal;
      }
    }
  }
}
</style>
